import { render, staticRenderFns } from "./changePasswordDialog.vue?vue&type=template&id=5223d710"
import script from "./changePasswordDialog.vue?vue&type=script&lang=js"
export * from "./changePasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./changePasswordDialog.vue?vue&type=style&index=0&id=5223d710&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports